import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

export enum concurAuthType {
    oldAuthVersion = 'OAuth_2.0',
    newAuthVersion = 'OAuth_2.0_Bearer'
}

@Metamodel.model({
    name: adfModelTypeMap.concur.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Concur_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Concur_DisplayText)
    ]
})
export class ConcurLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public isOldResource: boolean = false;
    public authType?: concurAuthType = concurAuthType.newAuthVersion;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_BaseUrl
    })
    public baseUrl?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseEncryptedEndpoints
    })
    public useEncryptedEndpoints?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseHostVerification
    })
    public useHostVerification?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UsePeerVerification
    })
    public usePeerVerification?: boolean;

    public isLegacyConnector: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
